import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _typeof from "@babel/runtime/helpers/typeof";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["initialTheme", "themeStyles", "baseName", "componentStyles"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var toKebab = function toKebab(str) {
  return str.replace(/(([a-z])(?=[A-Z][a-zA-Z])|([A-Z])(?=[A-Z][a-z]))/g, '$1-').toLowerCase();
};
var isComponentStylesThemeMap = function isComponentStylesThemeMap(componentStyles, theme) {
  return !!(componentStyles !== null && componentStyles !== void 0 && componentStyles[theme]);
};
export var convertComponentStylesToVariables = function convertComponentStylesToVariables(componentStyles, theme) {
  var styleSettings = isComponentStylesThemeMap(componentStyles, theme) ? componentStyles[theme] : componentStyles;
  return Object.keys(styleSettings).reduce(function (styles, componentName) {
    var componentSettings = styleSettings[componentName] || {};
    return _objectSpread(_objectSpread({}, styles), Object.keys(componentSettings).reduce(function (acc, paramName) {
      var variableName = "--".concat(toKebab(componentName), "-").concat(toKebab(paramName));
      return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, variableName, componentSettings[paramName]));
    }, {}));
  }, {});
};
var isStylesThemeMap = function isStylesThemeMap(themeStyles, theme) {
  return !!themeStyles[theme];
};
export var getThemeStyles = function getThemeStyles(themeStyles, theme) {
  return isStylesThemeMap(themeStyles, theme) ? themeStyles[theme] : themeStyles;
};
var getInitialTheme = function getInitialTheme(_ref) {
  var initialTheme = _ref.initialTheme,
    themeStyles = _ref.themeStyles;
  if (initialTheme) {
    return initialTheme;
  }
  var defaultTheme = Object.keys(themeStyles !== null && themeStyles !== void 0 ? themeStyles : {})[0];
  return _typeof(themeStyles === null || themeStyles === void 0 ? void 0 : themeStyles[defaultTheme]) === 'object' ? defaultTheme : undefined;
};
export var dataConverter = function dataConverter(_ref2) {
  var initialTheme = _ref2.initialTheme,
    themeStyles = _ref2.themeStyles,
    baseName = _ref2.baseName,
    componentStyles = _ref2.componentStyles,
    props = _objectWithoutProperties(_ref2, _excluded);
  return _objectSpread(_objectSpread({}, props), {}, {
    providerOptions: {
      initialTheme: getInitialTheme({
        initialTheme: initialTheme,
        themeStyles: themeStyles
      }),
      baseName: baseName,
      componentStyles: componentStyles,
      themeStyles: themeStyles
    }
  });
};